export default {
    'fumigation-certificates': 'شهادات التبخير',
    'fumigation-certificate': 'شهادة التبخير',
    'add-a-fumigation-certificate': 'إضافة شهادة تبخير',
}